import PrestationsManager from "@features/achats/components/prestations/PrestationsManager";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ConciergeBell } from "lucide-react";

export const Route = createFileRoute("/_app/achats/prestations/")({
  staticData: {
    title: "Prestations",
    icon: ConciergeBell,
    tab_icon: ConciergeBell,
    permission: PERMISSIONS.ACHATS.PRESTATIONS.VIEW,
    module: "achats",
    order: 30,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: PrestationsManager,
});
